export default "__VITE_ASSET__671936ae__"